import { useEffect, useRef, useState } from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import "swiper/css";
import { Swiper, SwiperSlide } from "swiper/react";

const Foto = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const swiperRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}api/auth/user-images-and-roles`
        );
        const userData = await response.json();

        if (response.ok) {
          const filteredData = userData.filter((user) => user.role === "guru");
          setData(filteredData);
        } else {
          setError(userData.msg || "Gagal memuat data.");
        }
      } catch {
        setError("Terjadi kesalahan saat mengambil data.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <section className="w-full px-4 py-12 bg-gray-50 dark:bg-gray-900">
      <div className="max-w-7xl mx-auto bg-white dark:bg-gray-800 rounded-3xl shadow-lg p-6 md:p-10">
        {/* Judul */}
        <h1 className="text-center text-3xl md:text-4xl font-extrabold text-yellow-500 mb-10">
          Pengajar & Staff
        </h1>

        {/* Konten */}
        <div className="relative">
          {/* Tombol kiri */}
          <button
            onClick={() => swiperRef.current?.swiper.slidePrev()}
            className="
              absolute -left-3 top-1/2 -translate-y-1/2 z-10
              bg-white dark:bg-gray-700
              shadow-md
              rounded-full
              p-2
              hover:scale-110
              transition
            "
          >
            <FiChevronLeft size={22} />
          </button>

          {/* Tombol kanan */}
          <button
            onClick={() => swiperRef.current?.swiper.slideNext()}
            className="
              absolute -right-3 top-1/2 -translate-y-1/2 z-10
              bg-white dark:bg-gray-700
              shadow-md
              rounded-full
              p-2
              hover:scale-110
              transition
            "
          >
            <FiChevronRight size={22} />
          </button>

          {loading ? (
            <p className="text-center text-gray-500">Loading...</p>
          ) : error ? (
            <p className="text-center text-red-500">{error}</p>
          ) : (
            <Swiper
              ref={swiperRef}
              spaceBetween={16}
              breakpoints={{
                0: { slidesPerView: 1.4 },
                480: { slidesPerView: 2 },
                768: { slidesPerView: 3 },
                1024: { slidesPerView: 4 },
                1280: { slidesPerView: 5 },
              }}
            >
              {data.map((user, index) => (
                <SwiperSlide key={index}>
                  <div
                    className="
                      h-[320px]
                      flex flex-col items-center
                      bg-gray-100 dark:bg-gray-700
                      rounded-2xl
                      shadow
                      hover:shadow-xl
                      hover:-translate-y-1
                      transition-all duration-300
                      p-4
                    "
                  >
                    {/* Foto */}
                    <img
                      src={
                        user.image?.filename
                          ? `${process.env.REACT_APP_API_URL}api/auth/users/image/${user.image.filename}`
                          : "/default-user.png"
                      }
                      alt={user.name}
                      className="
                        w-full
                        h-[220px]
                        object-cover
                        rounded-xl
                      "
                    />

                    {/* Nama */}
                    <p className="mt-4 text-center font-semibold text-gray-800 dark:text-white text-sm md:text-base">
                      {user.name}
                    </p>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          )}
        </div>
      </div>
    </section>
  );
};

export default Foto;
